export default {"src":"/_next/static/media/zrx.c94af7d6.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};